import React, { useState, useEffect, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import StarRatings from "react-star-ratings";
import { toast } from "react-toastify";
import businessService from "../../services/businessService";
import reviewService from "../../services/reviewService";
import socialService from "../../services/socialService";

export default function ReviewBusinessForm(props) {
  const business = props.business;
  const [stars, setStars] = useState(0);
  const [body, setBody] = useState("");
  const [title, setTitle] = useState("");
  const [socials, setSocials] = useState([]);
  const [reviewerID, setReviewerID] = useState(null);

  const isEligable = () => {
    if (!socials) {
      return false;
    }

    return socials.map((s) => s.status).includes("claimed");
  };

  useEffect(() => {
    console.log(props);
    fetchUserSocials();
  }, [props.jwt]);

  const fetchUserSocials = () => {
    socialService
      .fetchAllWithUserID(props.currentUserID)
      .then((response) => {
        setSocials(response.data);
      })
      .catch((err) => {
        toast.error(err.response.data.msg || "Error occurred");
      });
  };

  const submitReview = (e) => {
    e.preventDefault();
    if (!body || !title || !reviewerID) {
      toast.error("Add body, title, and handle");
      return;
    }
    const reviewData = {
      // reviewer_type: props.user.type,
      reviewee_type: "business",
      reviewer_id: reviewerID,
      reviewee_id: business.id,
    };
    reviewService
      .create(reviewData, title, body, stars, props.jwt)
      .then((response) => {
        toast.success("Review created!");
        props.onReviewSucceeded();
      })
      .catch((err) => {
        toast.error(err.response.data.msg || "Error occurred");
      });
  };

  if (!isEligable()) {
    return (
      <div className="col-6">
        <h3>Sorry, you dont have any claimed social handles</h3>
        <p>
          To write a review for {business.name} make sure you add a social and
          follow the instructions so we know you own it
        </p>
      </div>
    );
  }

  const getLabelforSocial = (item) => {
    var title = `${item.platform} : @${item.handle}`;
    if (item.status === "pending") {
      title += "-- must be verified to use";
    }
    return title;
  };

  return (
    <div className="col-6">
      <h3>Write a review about {business.name}</h3>
      <Form>
        <Form.Group controlId="formRating">
          <Form.Label>Rating</Form.Label>
          <br></br>
          <StarRatings
            rating={stars}
            starRatedColor="gold"
            starDimension="40px"
            starSpacing="1px"
            starHoverColor="gold"
            changeRating={(newRating) => setStars(newRating)}
            numberOfStars={5}
            name="rating"
          />
        </Form.Group>

        <Form.Group controlId="formTitle">
          <Form.Label>Review title</Form.Label>
          <Form.Control
            onChange={(e) => setTitle(e.target.value)}
            type="text"
            placeholder="Enter title"
          />
        </Form.Group>

        <Form.Group controlId="formBody">
          <Form.Label>Review body</Form.Label>
          <Form.Control
            onChange={(e) => setBody(e.target.value)}
            as="textarea"
            rows={3}
            placeholder="Heres my review ..."
          />
        </Form.Group>
        <Form.Group controlId="formBody">
          <Form.Label>I worked with them on:</Form.Label>
          {socials.map((item) => {
            return (
              <Form.Check
                onClick={() => {
                  setReviewerID(item.id);
                }}
                name="handleOptions"
                type="radio"
                disabled={item.status === "pending"}
                label={getLabelforSocial(item)}
                id={item.id}
              />
            );
          })}
        </Form.Group>
        <Button variant="primary" type="submit" onClick={submitReview}>
          Submit
        </Button>
      </Form>
    </div>
  );
}
